import { getFromLocalStorageByKey, setInLocalStorage } from './LocalStorage';

export enum Feature {
  ARTICLE_BUILDER = 'article_builder',
  BOOK_BUILDER = 'book_builder',
  BOOK_COLLABORATION = 'book_collaboration',
}

export function getFeatureIntroducedToUserAt(
  feature: Feature,
): Date | null | undefined {
  const storedValue = getFromLocalStorageByKey(
    `feature/${feature}/introducedAt`,
  );
  return storedValue && new Date(parseInt(storedValue));
}

export function recordFeatureIntroducedToUserAt(
  feature: Feature,
  datetime: Date,
) {
  setInLocalStorage(
    `feature/${feature}/introducedAt`,
    datetime.getTime().toString(),
  );
}
